export const phoneNumberToDigits = ({ phoneNumber = '' }) => {
  const phoneNumberWithoutCountryCode = phoneNumber.replace(/^\+\d+\./g, '');
  const phoneNumberDigits = phoneNumberWithoutCountryCode.match(/(\d+)/g);
  const phone = phoneNumberDigits && phoneNumberDigits.length > 0 ? phoneNumberDigits.join('') : '';
  return phone;
};
